import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CartStockStatusInterceptor implements HttpInterceptor {
  constructor(private snackbarFacade: SnackbarFacade) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((res: HttpResponse<any>) => {
        if (!(res instanceof HttpResponse)) {
          return;
        }

        if (res.body?.statusCode === 'lowStock') {
          const count = res.body.entry?.product?.stock?.stockLevel;
          const unit = res.body.entry?.saleUnit?.name;
          this.snackbarFacade.setSnack({
            title: 'Товар не добавлен в корзину',
            text: `В наличии только ${count} ${unit}. В корзину добавлен весь товар, имеющийся в наличии`,
            theme: SnackTheme.Yellow,
          });
        }
      }),
    );
  }
}
